interface Props {
  className?: string;
  style?: React.CSSProperties;
}

const DownArrow = ({ className, style }: Props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      className={`feather feather-chevron-down ${className || ''}`}
      style={style}
    >
      <polyline points='6 9 12 15 18 9'></polyline>
    </svg>
  );
};

export default DownArrow;
